import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './image-crop-modal.module.scss';

@classic
export default class SharedImageCropModal extends Component {
  styles = styles;
  get destinationElement() {
    return document.getElementById('modal-destination') || document.body;
  }
}
